export default "/images/c5f52cbc8a330bdbf75c2c8a41412bf5.png";